import { AutoSizer } from "react-virtualized/dist/es/AutoSizer";

import { asNumber, loadedDefinedMapWithDefault, asString, loadedDefinedMap } from "common/components/component-helpers";
import { LOADING, asUI, ActionSource } from "common/components/types";
import { pageMarginMedium } from "../lib/theme/theme";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import HorizontalList from "../ui/smart/horizontal-list/horizontal-list";
import { makeListItems } from "./list-material-renderer";
import EmptyWrapper from "webapp/ui/views/empty-wrapper/empty-wrapper";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useNetworkStatus } from "hooks/use-network-status";
import type { GlideFunctionalRenderer } from "common/components/uis";

export const HorizontalTilesMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[list, itemUI, numColumns, caption, onSeeAllVP, isGroupedPV, emptyMessageValue]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    const onLine = useNetworkStatus();
    const { onClick: onSeeAll } = useOnClickFromAction(onSeeAllVP, ActionSource.GridItem, ctx, env);
    if (list === LOADING || itemUI === LOADING || numColumns === LOADING) return env.renderProgress();
    const cols = asNumber(numColumns);

    const listItems = makeListItems(list, isGroupedPV, force, ctx, env, onLine);
    if (listItems === undefined) return null;

    if (listItems.isEmpty) {
        const emptyMessage = loadedDefinedMap(emptyMessageValue, asString);

        if (emptyMessage === undefined) return null;
        return <EmptyWrapper>{emptyMessage}</EmptyWrapper>;
    }

    return (
        <div>
            <AutoSizer disableHeight={true}>
                {({ width }) => {
                    const sidePadding = 2 * pageMarginMedium;

                    const totalGapSize = (cols - 1) * (pageMarginMedium / 2);
                    const colWidth = (width - sidePadding - totalGapSize) / cols;

                    return (
                        <HorizontalList
                            onSeeAllClick={onSeeAll}
                            title={loadedDefinedMapWithDefault(caption, "", asString)}
                            items={listItems.items}
                            groups={listItems.groups}
                            colWidth={colWidth}
                            screenWidth={width}
                            appKind={env.appEnvironment.appKind}>
                            {(item, i) => asUI(itemUI).render(item, env.with({ columnWidth: colWidth }), i)}
                        </HorizontalList>
                    );
                }}
            </AutoSizer>
        </div>
    );
};
